export enum PlayResult
{
    Win,
    Tie,
    Lost,
    LostWithPenalty
}
